import loadScript from './load_script'

export default class GoogleMap {

  constructor(mapElement, apiKey, location, mapData = {}) {
    this.mapElement = mapElement
    this.location = location
    this.mapData = mapData
    this.apiKey = apiKey
    
    this.map = undefined
    this.markers = []

    return new Promise((resolve) => {
      let mapsUrl = 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey + '&libraries=places&language=de-DE'
      loadScript(mapsUrl)
        .then(this._createMap.bind(this))
        .then(resolve(this))
    })
  }

  _createMap() {
    this.map = new google.maps.Map(this.mapElement, {
      disableDefaultUI: true,
      zoomControl: true,
    })

    this._centerMap()
    this._createPins()
    this._handleSidebar()
  }

  changeMapData(mapData) {
    this.location = mapData.location
    this.mapData = mapData.mapData
    this._deleteMarkers()
    this._createPins()
    this._centerMap()
  }

  focusPin(pinId) {
    const foundMarker = this.markers.find((marker) => { return marker.pinId === pinId })
    if (foundMarker) this._zoomToMarker(foundMarker)
  }

  _createPins() {
    this.mapData.forEach((pinData) => {
      this._createMarker(pinData)
    });
  }

  _createMarker(pinData) {
    let position = {
      lng: parseFloat(pinData.longitude),
      lat: parseFloat(pinData.latitude),
    }

    let marker = new google.maps.Marker({
      position: position,
      map: this.map,
      animation: google.maps.Animation.DROP,
      pinId: pinData.id,
      icon: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
    })

    if (document.body.getAttribute('data-environment') === 'test') {
      marker.setTitle(pinData.label)
    }

    let tooltip = up.element.createFromHTML('<div class="map--pin-tooltip"></div>')
    tooltip.innerText = pinData.label

    let infoWindow = new google.maps.InfoWindow({ content: tooltip })

    marker.addListener('mouseover', function() {
      infoWindow.open(this.map, marker)
    })

    marker.addListener('mouseout', function() {
      infoWindow.close(this.map, marker)
    })

    const self = this
    marker.addListener('click', () => {
      self._zoomToMarker(marker)
      up.emit(self.mapElement, 'app:map:pinClicked', { pinData })
    })

    this.markers.push(marker)
  }

  _deleteMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null)
    }
    this.markers = []
  }

  _zoomToMarker(marker) {
    this.map.setCenter(marker.position)
    this.map.setZoom(11)
    this._handleSidebar()

    up.reveal(this.mapElement, { behavior: 'smooth' })
  }

  _handleSidebar() {
    // Center and zoom map respecting sidebar.
    let sidebar = document.querySelector('.training-grounds--sidebar')
    if (sidebar && window.matchMedia("screen and (min-width:768px)").matches) {
      let sidebarWidth = sidebar.offsetWidth
      let offset = -0.3 * sidebarWidth
      this.map.panBy(offset, 0)
    } else if (sidebar) {
      let sidebarHeight = sidebar.offsetHeight
      let offset = -0.5 * sidebarHeight
      this.map.panBy(0, offset)
    }
  }

  _centerMap() {
    if (this.location) {
      let mapCenter = {
        lat: parseFloat(this.location.latitude),
        lng: parseFloat(this.location.longitude)
      }
      this.map.setCenter(mapCenter)
      this.map.setZoom(10)

      let queryMarker = new google.maps.Marker({
        position: mapCenter,
        map: this.map,
        title: 'Suchergebnis: ' + this.location.address
      })
      this.markers.push(queryMarker)

    } else {
      let mapCenter = {
        lat: 51.165691,
        lng: 10.451526
      }
      this.map.setCenter(mapCenter)
      this.map.setZoom(7)
    }

    this._handleSidebar()
  }


}
